import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=87804e9a&scoped=true"
import script from "./propaganda.vue?vue&type=script&lang=js"
export * from "./propaganda.vue?vue&type=script&lang=js"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=87804e9a&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87804e9a",
  null
  
)

export default component.exports